module.exports = __webpack_public_path__ + "media/18.ba7a7e76.wav";